// import LocalizedStrings from 'react-localization';
import { getStrings } from '../../Common/Localization/commonStrings';
import { fixedIncomeAndStateProgarmRecordStrings } from './LocalizedStrings/fixedIncomeAndStateRecordsStrings.js';
import { IQPReviewconfirmationStrings } from './LocalizedStrings/IQPReviewconfirmationLocalizedStrings.js';
import { verificationInformationStrings } from './LocalizedStrings/verificationInformationLocalizedStrings';
import { householdInformationStrings } from './LocalizedStrings/householdInformationLocalizedStrings';
import { eligibilityStrings } from './LocalizedStrings/eligibilityLocalizedStrings';
import { recertifyOrEndEnrollmentStrings } from './LocalizedStrings/recertifyOrEndEnrollmentLocalizedStrings';
import { yourContactInformationStrings } from './LocalizedStrings/yourContactInformationLocalizedStrings';
import { businessErrorStrings } from './LocalizedStrings/businessErrorLocalizedStrings';
import { inlineErrorStrings } from './LocalizedStrings/inlineErrorLocalizedStrings';


const localizedStrings = {
  verificationInformation: verificationInformationStrings,
  householdInformation: householdInformationStrings,
  yourContactInformation: yourContactInformationStrings,
  eligibility: eligibilityStrings,
  recertifyOrEndEnrollment: recertifyOrEndEnrollmentStrings,
  fixedIncomeAndStateProgemRecords: fixedIncomeAndStateProgarmRecordStrings,
  IQPReviewconfirmation: IQPReviewconfirmationStrings,
  errors: businessErrorStrings,
  inlineErrors: inlineErrorStrings,
  container: {
    strings: {
      en: {
        globalErrorMsg: 'We\'re sorry. The system is not available to provide your information at this time. Please try again later. Thank you.',
        defaultPage: 'Set Up or Update CARE/FERA Enrollment',
        review: 'Review',
        confirmation: 'Confirmation',
        accountNotEligible: 'Account Not Eligible',
        error: 'Error',
        serviceErrorET: 'SCE employees must provide gross annual income to qualify for the FERA discount program. Please uncheck any Public Assistance Program(s) selected and provide "Number of Adults" and "Number of Children" and "Total Annual Household Income.',
        serviceErrorRT: 'SCE employees must provide gross annual income to recertify their eligibility for the FERA discount program. Please uncheck any Public Assistance Program(s) selected and provide "Number of Adults" and "Number of Children" and "Total Annual Household Income.',
        selectedMsg:'My household is billed directly by SCE.',
        enrollmentPendingErrorCode:'ERR_101',
        enrollmentPending: 'This service account is already enrolled or recertified in the CARE or FERA program.', errorMsgHouseno: 'Please enter a house number','Please enter a house number.':'Please enter a house number.','Please enter a street name.':'Please enter a street name.',"Please enter Po box number":"Please enter Po box number","Please enter your city.":"Please enter your city.", 'Please enter zip code':'Please enter zip code'
      },
      ko: {
        globalErrorMsg: '우리가 미안해. 현재 귀하의 정보를 제공 할 수있는 시스템이 없습니다. 나중에 다시 시도하십시오. 고맙습니다.',
        defaultPage: 'CARE/ FERA 등록 설정 또는 업데이트하기',
        review: '고객님의 신청서를 검토해 보세요',
        confirmation: '확인',
        accountNotEligible: '자격이 없는 계정',
        error: '오류',
        serviceErrorET: 'SCE 직원이 FERA 할인 프로그램에 대한 자격을 얻으려면 총 연간 소득을 제공해야 합니다. 선택한 공공 지원 프로그램의 선택 표시를 지우고 “성인 수" 및 "자녀 수" 그리고 "총 연간 가계 소득"을 제공해 주십시오. ',
        serviceErrorRT: 'SCE이 직원이 FERA 할인 프로그램에 대한 자격 요건을 재인증 받으려면 연간 총 소득을 제공해야 합니다. 선택한 공공 지원 프로그램의 선택 표시를 지우고 "성인 수" 및 "자녀 수" 그리고 "총 연간 가계 소득"을 제공해 주십시오. ',"Please enter a house number.":"집 번호를 입력하세요.","Please enter a street name.":"도로 이름을 입력하세요.","Please enter Po box number":"우편함 번호를 입력하세요.","Please enter your city.":"도시를 입력하세요.","Please enter zip code":"우편번호를 입력하세요.",
      },
      es: {
        globalErrorMsg: 'Lo sentimos. El sistema no está disponible para proporcionar su información en este momento. Por favor, inténtelo de nuevo más tarde. Gracias.',
        defaultPage: 'Activación o actualización de la inscripción en CARE/FERA',
        review: 'Revisa tu solicitud',
        confirmation: 'Confirmación',
        accountNotEligible: 'La verificación no fue posible',
        error: 'Error',
        serviceErrorET: 'Los empleados de SCE deben proporcionar un ingreso anual bruto para calificar para el programa de descuento FERA. Desmarque cualquier Programa de asistencia pública seleccionado y proporcione "Número de adultos" y "Número de hijos" y "Ingresos familiares totales anuales".',
        serviceErrorRT: 'Los empleados de SCE deben proporcionar ingresos anuales brutos para recertificar su elegibilidad para el programa de descuento FERA. Desmarque cualquier Programa de asistencia pública seleccionado y proporcione "Número de adultos" y "Número de hijos" y "Ingresos familiares totales anuales". ',"Please enter a house number.":"Por favor, ingrese su número de casa.","Please enter a street name.":"Por favor, ingrese el nombre de su calle.","Please enter Po box number":"Por favor, ingrese el número de su apartado postal.","Please enter your city.":"Por favor, ingrese su ciudad.","Please enter zip code":"Por favor, ingrese el código postal."
      },
      vi: {
        globalErrorMsg: 'Chúng tôi xin lỗi. Hệ thống không có sẵn để cung cấp thông tin của bạn tại thời điểm này. Vui lòng thử lại sau. Cảm ơn bạn.',
        defaultPage: 'Khởi Lập hhoặc Cập Nhật Ghi Danh CARE/FERA',
        review: 'Xem Lại Đơn của Quý Vị',
        confirmation: 'Xác Nhận',
        accountNotEligible: 'Trương Mục Không Hợp Lệ',
        error: 'Không',
        serviceErrorET: 'Nhân viên SCE phải cung cấp tổng lợi tức hàng năm để hội đủ điều kiện hưởng chương trình giảm giá FERA. Xin vui lòng bỏ đánh dấu chọn bất kỳ (các) Chương Trình Hỗ Trợ Công nào và cung cấp "Số Người Lớn" và "Số Trẻ Em " và "Tổng Lợi Tức Hàng Năm của Gia Đình." ',
        serviceErrorRT: 'Nhân viên SCE phải cung cấp tổng lợi tức hàng năm để tái xác nhận sự hợp lệ được hưởng chương trình giảm giá FERA. Xin vui lòng bỏ đánh dấu chọn bất kỳ (các) Chương Trình Hỗ Trợ Công nào và cung cấp "Số Người Lớn" và "Số Trẻ Em " và "Tổng Lợi Tức Hàng Năm của Gia Đình." ', "Please enter a house number.":"Vui lòng nhập số nhà của bạn.","Please enter a street name.":"Vui lòng nhập tên đường của bạn.","Please enter Po box number":"Vui lòng nhập số hộp thư.","Please enter your city.":"Vui lòng nhập thành phố của bạn.","Please enter zip code":"Vui lòng nhập mã bưu điện."
      },
      zh: {
        globalErrorMsg: '我们很抱歉。 系统目前无法提供您的信息。 请稍后再试。 谢谢。',
        defaultPage: '設定或更新 CARE/FERA 加入資料',
        review: '檢查您的申請資料',
        confirmation: '確認',
        accountNotEligible: ' 帳戶不符資格',
        error: '错误',
        serviceErrorET: 'SCE 員工必須提供總年收入，才能證明其 FERA 折扣計劃資格。請取消勾選任何已選取的公共援助計劃，然後提供「成人人數」、「兒童人數」及「家庭總年收入」等資料。 ',
        serviceErrorRT: 'SCE 員工必須提供總年收入，才能重新認證其 FERA 折扣計劃資格。請取消勾選任何已選取的公共援助計劃，然後提供「成人人數」、「兒童人數」及「家庭總年收入」等資料。 ', 
        "Please enter a house number.":"请输入您的门牌号。","Please enter a street name.":"请输入您的街道名称。","Please enter Po box number":"请输入您的邮政信箱号码。","Please enter your city.":"请输入您的城市。","Please enter zip code":"请输入您的邮政编码。"        
      }
    },
    common: ['cancel', 'tnc']
  },
  redirectionBlock: {
    strings: {
      en: {
      prevurlhash:'#previousService',
      disabled :'sceDisabled',
      sceprimary:'sceSmPrimary'
      }
    },
    common: ['next', 'cancel', 'save', 'previous', 'submit']
  },
  cancelDialog: {
    strings: {
      en: {
        ifYouLoginNow: 'If you login now, you will have to re-enter all of your information. Do you want to log in?',
        noCancelLogin: 'No, Cancel Login',
        yesLogin: 'Yes, Login'
      },
      es: {
      }
    },
    common: ['areYouSure', 'yourProgressWontBeSaved', 'noContinue', 'yesCancel']
  },

};
export const getLocalizedStrings = (componentName) => {
  //app.logger.getLogger().info('Comp Name' + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
  // return new LocalizedStrings(strings);
};
